import { Controller } from "@hotwired/stimulus"

// Opens the feedback panel from a DECOUPLED trigger (e.g. the mobile bottom-nav
// button), which lives in a different part of the DOM than the feedback widget
// itself. Rather than reach across controllers, it dispatches a window-level
// CustomEvent("feedback:open"); the `feedback` controller listens for it and
// opens its panel. CSP forbids inline onclick, so this stays as a Stimulus
// action: data-controller="feedback-trigger" + data-action="feedback-trigger#open".
export default class extends Controller {
  open(event) {
    event?.preventDefault()
    window.dispatchEvent(new CustomEvent("feedback:open"))
  }
}
